import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInputComponent} from "ngx-material-file-input";
import {ReplaySubject} from "rxjs";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {delay, first, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesPaymentImportService} from "../../../../shared/services/receivables-payment-import.service";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";

@Component({
  selector: 'app-receivables-payment-import',
  templateUrl: './receivables-payment-import.component.html',
  styleUrls: ['./receivables-payment-import.component.scss']
})
export class ReceivablesPaymentImportComponent implements OnInit, OnDestroy  {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  receivablesPaymentImportForm: FormGroup;
  receivablesPaymentImportFormValid = false;
  fileControl: FormControl;
  fileMaxSize = 5242880 * 20;
  processingRequest = false;
  formErrors = {};
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private receivablesPaymentImportService: ReceivablesPaymentImportService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesPaymentImportForm = fb.group({
      name: fb.control('', [Validators.required]),
      fileContent: fb.control('', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.receivablesPaymentImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.receivablesPaymentImportFormValid = this.receivablesPaymentImportForm.valid;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  import(): void {
    if (!this.receivablesPaymentImportForm.valid) {
      this.receivablesPaymentImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.receivablesPaymentImportForm, this.formErrors);
    this.formErrors = {};


    this.receivablesPaymentImportService.import(this.receivablesPaymentImportForm.value)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Rozpoczynanie importowania danych', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/naleznosci/wplaty/lista_importow']);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas tworzenia importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.receivablesPaymentImportForm, this.formErrors);
        }
      })
    ;
  }

  fileSelected(file: FileBase64): void {
    this.receivablesPaymentImportForm.get('fileContent').setValue(file.base64);
    this.receivablesPaymentImportForm.get('name').setValue(file.filename);
  }
}
